
import { defineComponent, onMounted, ref, watchEffect } from "vue";
import { Apollo } from "@/core/services";
import { CUSTOMER_DAILY_REVENUE } from "@/modules/customer/customers/graphql/Queries";

import { config, asideTheme } from "@/core/helpers/config";

import { getCSSVariableValue } from "@/assets/ts/_utils";
export default defineComponent({
	name: "WidgetOrders",
	props: {
		widgetClasses: String,
		chartColor: String,
		chartHeight: String,
		icon: String,
		title: String,
		titleDescription: String,
		count: String,
		background: String,
		uuid: { type: String, default: null },
		link: String,
		locale: String,
	},
	setup(props) {
		const color = ref(props.chartColor);
		const currency = ref("");
		const locale = ref(props.locale);
		const glob = ref(asideTheme);
		const themeColor = getCSSVariableValue("--lt-primary-color");

		const chartOptions = ref({
			series: [
				{
					name: "Net Profit",
					data: [],
				},
			],
			chart: {
				foreColor: glob.value == "dark" ? themeColor : "#000",
				zoom: {
					enabled: false,
				},
				shadow: {
					enabled: true,
					color: "#000",
					top: 18,
					left: 7,
					blur: 10,
					opacity: 1,
				},
				toolbar: {
					show: false,
				},
			},
			// colors: [`${config.value.asaide.theme == "dark" ? "#ffdd00" : "#000"}`],
			colors: [themeColor],
			dataLabels: {
				enabled: true,
				style: {
					colors: ["#000"],
					fontSize: "10px",
				},
				formatter: function(value) {
					if (value == 0) {
						return value.toLocaleString(locale.value);
					}
					return `${currency.value} ${value.toLocaleString(locale.value)}`;
				},
			},
			stroke: {
				curve: "smooth",
				width: 1.5,
			},
			title: {
				text: "",
				align: "left",
			},
			grid: {
				borderColor: "transparent",
				row: {
					colors: ["#373737", "transparent"],
					opacity: 0.5,
				},
			},
			markers: {
				size: 4,
			},
			xaxis: {
				categories: ['0'],
				title: {
					text: [""],
				},
				labels: {
					offsetY: 10,
					rotate: -45,
					rotateAlways: true,
					style: {
						colors: glob.value == "dark" ? themeColor : "#000",
						fontSize: "12px",
					},
				},
			},
			yaxis: {
				labels: {
					style: {
						colors: glob.value == "dark" ? themeColor : "#000",
						fontSize: "12px",
					},
				},
			},
			theme: {
				palette: "palette7",
			},
			legend: {
				position: "top",
				horizontalAlign: "right",
				floating: true,
				offsetY: -25,
				offsetX: -5,
			},
		});

		const series = ref([
			{
				name: "Net Sale",
				data: [0],
			},
		]);

		const CustomerDailyRevenue = () => {
			Apollo.watchQuery({
				query: CUSTOMER_DAILY_REVENUE,
				fetchPolicy: "network-only",
				nextFetchPolicy: "cache-only",
				errorPolicy: "all",
				variables: {
					uuid: String(props.uuid),
				},
			}).subscribe(({ data, errors }) => {
				const daily_details = JSON.parse(data.customer_daily_revenue);
				chartOptions.value.xaxis.title.text.fill(daily_details.date_range);
				chartOptions.value.xaxis.categories.push(...daily_details.dates);
				const arr = Array(daily_details.dates.length).fill(0);
				series.value[0]["data"].push(...arr);
				if (daily_details.daily_revenue != 0)
        {
          daily_details.daily_revenue.forEach((revenue) => {
            series.value[0]["data"][chartOptions.value.xaxis.categories.indexOf(revenue.date)] = parseFloat(revenue.order_total);
          });
          series.value[0]["data"].shift();
        }
				chartOptions.value.xaxis.categories.shift();
        chartOptions.value.xaxis.categories.forEach((date,index, array) => {
          array[index] = `${date} ${daily_details.mon}`;
        });
				currency.value = daily_details?.currency;
			});
		};

		CustomerDailyRevenue();

		watchEffect(() => {
			// charColor.value  = config.value.aside.theme
		});
		return {
			chartOptions,
			series,
			config,
			glob,
		};
	},
});
